<template>
  <v-dialog
    v-model="isActive"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :max-width="$vuetify.breakpoint.xsOnly ? '100%' : '700'"
    persistent
  >
    <v-card class="d-flex flex-column mobile-full-height">
      <!-- Header -->
      <div :class="[$vuetify.breakpoint.xsOnly ? 'mobile-header px-4' : 'pl-8 pr-8', 'pt-6 pb-0 lighten-3 font-weight-medium text-h5']">
        <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          @click="$emit('cancel')"
        >
          <v-icon size="32">
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <span>ข้อกำหนดและเงื่อนไขการให้บริการ</span>
      </div>

      <!-- Scrollable Content -->
      <div class="flex-grow-1 content-container scrollable-padding">
        <v-card-text
          class="scrollable-content overflow-content"
        >
          <div>
            <ul>
              <li style="list-style: decimal;">
                การรับชำระเงิน
                <ul>
                  <li style="list-style: disc">
                    ทาง Sellsuki รับชำระเงินโดยการโอนเงินผ่านบัญชีธนาคาร, บัตรเครดิต/เดบิต และ QR Code
                  </li>
                  <li style="list-style: disc">
                    กรณีลูกค้าต้องการยกเลิกการชำระเงิน (Void) ผ่านบัตรเครดิต/เดบิตหรือ QR Code
                    และระยะเวลาคืนเงินภายใน 7 วันทำการ หรือขึ้นอยู่กับธนาคารผู้ออกบัตร
                  </li>
                  <li style="list-style: disc">
                    กรณีลูกค้าต้องการเงินคืน (Refund) จากการชำระเงินผ่านบัตรเครดิต/เดบิต
                    ลูกค้าจะถูกหักค่าธรรมเนียม 2% และระยะเวลาคืนเงินภายใน 15-30 วันทำการ
                    หรือขึ้นอยู่กับธนาคารผู้ออกบัตร
                  </li>
                </ul>
              </li>

              <li style="list-style: decimal;">
                Credit term
                <ul>
                  <li style="list-style: disc;">
                    ทาง Sellsuki ไม่มี Credit term หากไม่มีการชำระเงินเข้ามา
                    จะไม่สามารถทำการเปิดให้บริการได้
                  </li>
                </ul>
              </li>

              <li style="list-style: decimal;">
                การส่งเอกสาร
                <ul>
                  <li style="list-style: disc;">
                    ทาง Sellsuki มีนโยบายในการส่งเอกสารทาง Email เท่านั้น
                  </li>
                </ul>
              </li>

              <li style="list-style: decimal;">
                หนังสือรับรองการหักภาษี ณ ที่จ่าย
                <ul>
                  <li style="list-style: disc;">
                    ทาง Sellsuki จะมีการขอหนังสือรับรองการหักภาษี ณ ที่จ่ายตัวจริงจากทางลูกค้า
                  </li>
                </ul>
              </li>

              <li style="list-style: decimal;">
                ใบกำกับภาษี
                <ul>
                  <li style="list-style: disc;">
                    ทาง Sellsuki จะส่งเป็น E-Tax ผ่านทาง Email เท่านั้น
                  </li>
                </ul>
              </li>

              <li style="list-style: decimal;">
                การเปิดให้บริการ
                <ul>
                  <li style="list-style: disc;">
                    ระบบจะดำเนินการเปิดแพ็กเกจภายใน 1 - 2 วันทำการ
                  </li>
                </ul>
              </li>

              <li style="list-style: decimal;">
                ข้อกำหนดในการใช้งาน
                <ul>
                  <li style="list-style: disc;">
                    ขอสงวนสิทธิ์ในการคืนเงินสำหรับลูกค้าที่ใช้บัญชี LINE Official Account
                    ที่ผิดต่อข้อบังคับของบริษัท LY Corporation ในทุกกรณี<br>
                    สามารถดูเพิ่มเติมได้ที่
                    <a
                      href="http://terms.line.me/line_terms?lang=th"
                      target="_blank">
                      http://terms.line.me/line_terms
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </v-card-text>
      </div>

      <!-- Fixed Bottom Section -->
      <div class="fixed-bottom">
        <v-card-text class="pb-0 pt-0 px-4 pl-6 d-none d-sm-block">
          <v-checkbox
            v-model="agree"
            class="mt-0 pb-0 pt-0"
            label="ข้าพเจ้ายอมรับข้อกำหนดและเงื่อนไขในการให้บริการนี้"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 d-none d-sm-block">
          <div class="actions-container">
            <v-btn
              color="btn-close"
              rounded
              :min-width="$vuetify.breakpoint.xsOnly ? '120' : '150'"
              exact
              @click="$emit('cancel')">
              ปิด
            </v-btn>
            <v-btn
              class="ml-4"
              color="primary"
              rounded
              :min-width="$vuetify.breakpoint.xsOnly ? '120' : '150'"
              :disabled="!agree"
              style="letter-spacing: normal"
              @click="$emit('accept')">
              ยอมรับ
            </v-btn>
          </div>
        </v-card-actions>

        <v-card-text class="pb-0 pt-4 px-4 pl-4 d-block d-sm-none">
          <v-checkbox
            v-model="agree"
            class="mt-0 pb-0 pt-0"
            label="ข้าพเจ้ายอมรับข้อกำหนดและเงื่อนไขในการให้บริการนี้"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions class="px-4 pt-0 pb-4 d-block d-sm-none">
          <div class="actions-container">
            <v-btn
              class="ml-4 py-4 h-"
              color="primary"
              rounded
              min-width="100%"
              :disabled="!agree"
              style="font-size: 20px;letter-spacing: normal;height: 50px;"
              @click="$emit('accept')">
              ยอมรับ
            </v-btn>
          </div>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OrderPrivacyPolicy',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      agree: false
    }
  },
  computed: {
    isActive: {
      get() {
        return this.active
      },
      set(val) {
        this.$emit('update:active', val)
      }
    }
  }
}
</script>

<style scoped>
li ul li::marker {
    font-size: 9px; /* หรือเป็น px เช่น 12px */
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.btn-close {
  background: #E5E7EB !important;
  border: none !important;
  color: #666666;
  letter-spacing: 0 !important;
}

.v-btn:before {
  letter-spacing: 0 !important;
}

.v-btn--is-elevated {
  box-shadow: none;
}

.v-card__subtitle, .v-card__text {
  font-size: 16px;
}

.theme--light.v-card {
  color: #000000;
}

@media (max-width: 600px) {
  .mobile-full-height {
    height: 100vh !important;
  }

  .content-container {
    position: relative;
    height: calc(100vh - 200px); /* ปรับความสูงให้เหลือพื้นที่สำหรับ header และ bottom section */
    overflow: hidden;
    margin-top: 16px;
  }

  .scrollable-content {
    height: 100%;
    overflow-y: auto;
    padding: 16px;
  }

  .fixed-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
  }

  .actions-container {
    padding: 0;
  }

  /* ปรับขนาดฟอนต์สำหรับ mobile */
  .text-h5 {
    font-size: 1.25rem !important;
  }

  .overflow-content {
    max-height: 100%;
    overflow-y: auto;
  }

  .scrollable-padding {
    padding: 0;
    margin-top: 0px;
    padding-bottom: 145px;
  }

  .mobile-header {
    padding: 28px !important;
    display: flex;
    align-items: center;
    position: relative;
    background: #FFF;
  }

  .mobile-header span {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    width: 70%; /* ปรับความกว้างของ text ให้ไม่ทับกับปุ่ม */
    text-align: center;
    font-size: 18px !important
  }

  .mobile-header .v-btn {
    position: fixed;
    left: 8px;
  }
}
@media (min-width: 600px) {
  .overflow-content {
    max-height: 400px; overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
  }
  .scrollable-padding {
    padding: 24px 28px 24px 28px;
  }
}</style>
